export default __webpack_public_path__ + "static/media/email.4bbf7ae4.png";